import React from "react";
import Card from "./Card";
import {
  PiNumberCircleOneFill,
  PiNumberCircleTwoFill,
  PiNumberCircleThreeFill,
} from "react-icons/pi";

import { SiGoogledocs } from "react-icons/si";
import { IoLocationOutline } from "react-icons/io5";
import { IoMdTime } from "react-icons/io";
import { MdOutlineGroups } from "react-icons/md";
import { IoCheckbox } from "react-icons/io5";
import { FaPenSquare } from "react-icons/fa";

const PulseFit = () => {
  const cards = [
    {
      title: "My Role",
      content:
        "As the UX Designer, I led the end-to-end design process for the workout app, from research and user flows to wireframing and prototyping. My role involved creating intuitive user experiences, designing seamless interfaces, and ensuring the app met the needs of fitness enthusiasts of all ages.",
      bgColor: "bg-h-color",
      textColor: "text-white",
    },
    {
      title: "Key Deliverables",
      content:
        "Conducting interviews, paper and digital wireframing, low and high-fidelity prototyping, conducting usability studies, accounting for accessibility, iterating on designs and responsive design.",
      bgColor: "bg-cg",
      textColor: "text-black",
    },
    {
      title: "The Problem",
      content:
        "People often struggle with finding workout plans that suit their fitness goals due to complex interfaces, lack of personalization, and inconvenient payment options. Users need a simpler way to discover and purchase the right plans, with clear navigation and instant access to their workouts. The challenge is making fitness more accessible and tailored to individuals of all ages, regardless of their experience level.",
      bgColor: "bg-cg",
      textColor: "text-black",
    },
    {
      title: "My Goals",
      content:
        "Our app aims to make fitness accessible for everyone by streamlining the process of finding and purchasing workout plans. Through an intuitive design and personalized recommendations, users can quickly access workout options tailored to their goals. Flexible payment choices and immediate access to purchased plans enable users to integrate fitness into their busy lives with ease and convenience.",
      bgColor: "bg-h-color",
      textColor: "text-white",
    },
  ];
  return (
    <>
      <div className="container mx-auto py-10  px-10">
        <div className="grid grid-cols-2 gap-2">
          <div className="justify-items-center content-center">
          <div className="text-left lg:w-4/12 ml-20">
            <h1>Case Study:</h1>
            </div>
            <h1 className="text-h-color  text-3xl">
              PulseFit: <br />
              Workout App
            </h1>
          </div>
          <div className="bg-cg justify-items-center py-12">
            <img
              src="/assets/img/plusefit/plusefit.png"
              className="w-6/12"
              alt=""
            />
          </div>
        </div>
      </div>
      <section className="px-10 pt-10 ">
        <div className="container mx-auto">
          <div className="justify-items-center text-center ">
            <h1 className="text-2xl font-bold text-h-color border-b-2 border-h-color pb-3 w-full ">
              Project Overview
            </h1>
          </div>

          <div>
            <h1 className="text-h-color text-2xl font-bold mt-20 mb-5">
              PulseFit: Workout App
            </h1>
            <p className="text-justify text-lg">
              This workout app enables users to book and buy workout plans
              tailored to their fitness goals. With access to a wide range of
              classes, users can easily work out through the app. The app is
              designed for people of all ages who enjoy staying active and fit.
              It’s the perfect platform for fitness enthusiasts looking for
              convenience and variety.
            </p>
          </div>

          <div className="bg-cg rounded-xl shadow-md  mt-10 pt-10 mx-10">
            <div className="justify-items-center items-center">
              <img src="/assets/img/plusefit/3in1.png" className="lg:w-6/12 md:w-5/12 sm:w-4/12" alt="" />
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-5 mt-20 lg:px-28 ">
            {cards.map((card, index) => (
              <Card
                key={index}
                title={card.title}
                content={card.content}
                bgColor={card.bgColor}
                textColor={card.textColor}
              />
            ))}
          </div>
          <div className="mt-20 px-5 justify-items-center">
            <img src="/assets/img/plusefit/problem.jpeg" alt="" />
          </div>

          <div class="flex items-center justify-center py-20">
            <div class="grid grid-cols-2 w-3/4">
              {/* <!-- Left Column --> */}
              <div class="text-left h-96 content-center justify-items-end">
                <h1 class="lg:text-2xl font-semibold text-h-color  text-right pr-10  ">
                  Understanding <br />
                  The User
                </h1>
              </div>
              {/* <!-- Right Column --> */}
              <div class="border-l-2 border-black h-96 content-center  pl-10">
                <ul class="list-disc space-y-2 text-gray-800">
                  <li>User Research</li>
                  <li>Persona</li>
                  <li>Pain Points</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="py-10">
            <h1 className="text-2xl font-bold">User Research</h1>
            <p className="text-justify mt-5 ">
              For my workout app project, I conducted thorough research by
              developing user personas, mapping user journeys, crafting a goal
              statement, and designing user flows. User personas helped identify
              diverse fitness needs and preferences, while user journeys
              outlined the steps users take to achieve their fitness goals. The
              goal statement focused on enhancing accessibility and efficiency
              in fitness planning. User flows were created to streamline
              navigation, ensuring a smooth and intuitive experience from
              discovering workout plans to making purchases. This
              research-driven approach ensures the app meets user needs
              effectively and efficiently.
            </p>
          </div>

          <div className="py-10 ">
            <h1 className="text-2xl font-bold">User Persona</h1>
            <div className=" px-5 py-10 justify-items-center">
              <img src="/assets/img/plusefit/girl.png" alt="" />
            </div>
          </div>
          <div className="py-10 ">
            <h1 className="text-2xl font-bold">User Pain Points</h1>
          </div>

          {/* <div className="py-10 lg:px-60">
            <div className="grid lg:grid-cols-3 lg:gap-20 gap-5">
              <div className="border-2 rounded-xl   border-red-600 text-center mt-5 px-10 py-10 ">
                <div className="justify-items-center">
                  <PiNumberCircleOneFill className="text-7xl text-red-600 " />
                </div>

                <h1 className="text-2xl font-bold ">Complex Navigation</h1>
                <p className="text-justify mt-5">
                  Many workout apps have cluttered interfaces and complicated
                  navigation, making it difficult for users to find specific
                  plans or features quickly.
                </p>
              </div>
              <div className="border-2 rounded-xl   border-red-600 text-center mt-5 px-10 py-10 ">
                <div className="justify-items-center">
                  <PiNumberCircleTwoFill className="text-7xl text-red-600 " />
                </div>

                <h1 className="text-2xl font-bold ">Lack of personalization</h1>
                <p className="text-justify mt-5">
                   Users often struggle with apps that offer generic workout
                  plans, lacking tailored recommendations based on individual
                  fitness levels, goals, or preferences.
                </p>
              </div>
              <div className="border-2 rounded-xl   border-red-600 text-center mt-5 px-10 py-10 ">
                <div className="justify-items-center">
                  <PiNumberCircleThreeFill className="text-7xl text-red-600 " />
                </div>

                <h1 className="text-2xl font-bold ">
                  High cost and subscription issues
                </h1>
                <p className="text-justify mt-5">
                  Users may face frustration with expensive subscription models
                  or hidden fees, which can be a barrier to accessing quality
                  workout plans and features.
                </p>
              </div>
            </div>
          </div> */}
          <div className="py-10 px-5 md:px-10 lg:px-20">
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10">
    {/* Card 1 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleOneFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">Complex Navigation</h1>
      <p className="text-justify mt-4">
        Many workout apps have cluttered interfaces and complicated navigation,
        making it difficult for users to find specific plans or features quickly.
      </p>
    </div>

    {/* Card 2 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleTwoFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">Lack of Personalization</h1>
      <p className="text-justify mt-4">
        Users often struggle with apps that offer generic workout plans, lacking
        tailored recommendations based on individual fitness levels, goals, or
        preferences.
      </p>
    </div>

    {/* Card 3 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleThreeFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">
        High Cost and Subscription Issues
      </h1>
      <p className="text-justify mt-4">
        Users may face frustration with expensive subscription models or hidden
        fees, which can be a barrier to accessing quality workout plans and
        features.
      </p>
    </div>
  </div>
</div>

          <div class="flex items-center justify-center py-20">
            <div class="grid grid-cols-2 w-3/4">
              {/* <!-- Left Column --> */}
              <div class="text-left h-96 content-center justify-items-end">
                <h1 class="text-2xl font-semibold text-h-color  text-right pr-10  ">
                  Starting the <br /> Design Process
                </h1>
              </div>
              {/* <!-- Right Column --> */}
              <div class="border-l-2 border-black h-96 content-center  pl-10">
                <ul class="list-disc space-y-2 text-gray-800">
                  <li>Sitemap</li>
                  <li>Paper Wireframes</li>
                  <li>Digital Wireframes</li>
                  <li>Low Fidelity Prototype</li>
                  <li>Usability Studies</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="pt-10 ">
            <h1 className="text-2xl font-bold">Sitemap</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/plusefit/sitemap.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Paper Wireframes</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/plusefit/paperwire.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Digital Wireframes</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/plusefit/wireframe.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold">Low-Fidelity Prototype</h1>
            <div className="justify-items-center py-10">
              <img
                src="/assets/img/plusefit/LowFidelity.png"
                className="text-center lg:w-6/12"
                alt=""
              />
            </div>
            <h1 className="text-2xl font-bold text-yellow-300">
              Usability Study:Parameters
            </h1>
            <div className="py-10 lg:px-60">
              <div className="grid grid-cols-2 gap-5">
                <div className="border-2 rounded-xl   text-center mt-5 px-5 py-10 ">
                  <div className="justify-items-center my-5">
                    <SiGoogledocs className="text-5xl lg:text-7xl  text-yellow-300" />
                  </div>
                  <h1 className="lg:text-2xl font-bold ">Study type:</h1>
                  <p className=" mt-5">Moderated Usability study</p>
                </div>
                <div className="border-2 rounded-xl    text-center mt-5 px-5 py-10 ">
                  <div className="justify-items-center my-5">
                    <IoLocationOutline className="text-5xl lg:text-7xl text-yellow-300 " />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Location:</h1>
                  <p className=" mt-5">India</p>
                </div>
                <div className="border-2 rounded-xl   text-center mt-5 px-5 py-10 ">
                  <div className="justify-items-center ">
                    <MdOutlineGroups className="text-5xl lg:text-7xl text-yellow-300" />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Participants</h1>
                  <p className=" mt-5">5 participants</p>
                </div>
                <div className="border-2 rounded-xl  text-center mt-5 px-5 py-10 ">
                  <div className="justify-items-center">
                    <IoMdTime className="text-5xl lg:text-7xl text-yellow-300 " />
                  </div>

                  <h1 className="lg:text-2xl font-bold ">Length:</h1>
                  <p className=" mt-5">20-30 mintues</p>
                </div>
              </div>
            </div>
            <h1 className="text-2xl font-bold text-red-500">
              Usability Study:Findings
            </h1>
            {/* <div className="py-10 lg:px-60">
              <div className="grid lg:grid-cols-3 gap-5">
                <div className="border-2 rounded-xl   text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center">
                    <PiNumberCircleOneFill className="text-7xl text-red-600" />
                  </div>

                  <h1 className="text-2xl font-bold ">Cart</h1>
                  <p className="text-justify mt-5">
                    Users couldn’t find the option to remove an item from the
                    cart.
                  </p>
                </div>
                <div className="border-2 rounded-xl    text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center">
                    <PiNumberCircleTwoFill className="text-7xl text-red-600 " />
                  </div>

                  <h1 className="text-2xl font-bold ">Payment</h1>
                  <p className=" text-justify mt-5">
                    Users only have a one payment option that is credit or debit
                    cards 
                  </p>
                </div>
                <div className="border-2 rounded-xl   text-center mt-5 px-10 py-10 ">
                  <div className="justify-items-center">
                    <PiNumberCircleThreeFill className="text-7xl text-red-600" />
                  </div>

                  <h1 className="text-2xl font-bold ">Workout Plans</h1>
                  <p className=" text-justify mt-5">
                    User didn’t have a option to see a trial class to get  a
                    preview of the plan
                  </p>
                </div>
              </div>
            </div> */}
            <div className="py-10 px-5 md:px-10 lg:px-20">
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10">
    {/* Card 1 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleOneFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">Cart</h1>
      <p className="text-justify mt-4">
        Users couldn’t find the option to remove an item from the cart.
      </p>
    </div>

    {/* Card 2 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleTwoFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">Payment</h1>
      <p className="text-justify mt-4">
        Users only have a one payment option that is credit or debit cards.
      </p>
    </div>

    {/* Card 3 */}
    <div className="border-2 rounded-xl border-red-600 bg-white text-center px-6 py-8 shadow-md hover:shadow-lg transition-shadow">
      <div className="flex justify-center mb-4">
        <PiNumberCircleThreeFill className="text-6xl text-red-600" />
      </div>
      <h1 className="text-xl md:text-2xl font-bold">Workout Plans</h1>
      <p className="text-justify mt-4">
        Users didn’t have an option to see a trial class to get a preview of the
        plan.
      </p>
    </div>
  </div>
</div>

            <div class="flex items-center justify-center py-20">
              <div class="grid grid-cols-2 w-3/4">
                {/* <!-- Left Column --> */}
                <div class="text-left h-96 content-center justify-items-end">
                  <h1 class="text-2xl font-semibold text-h-color   pr-10  ">
                    Refining the <br /> Design
                  </h1>
                </div>
                {/* <!-- Right Column --> */}
                <div class="border-l-2 border-black h-96 content-center  pl-10">
                  <ul class="list-disc space-y-2 text-gray-800">
                    <li>Mockups</li>
                    <li>Hi-Fi Prototype</li>
                    <li>Accessibilty</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="pt-10">
              <h1 className="text-2xl font-bold">Mockups</h1>
              <p className="text-justify mt-5 ">
                Based on the insights from the usability study, I made changes
                to improve the app’s checkout flow. One of the changes I made
                was that i added the remove from cart option.
              </p>
              <div className="lg:flex justify-around pt-10 ">
                <img src="/assets/img/plusefit/mockups.png" className="my-2" alt="" />
                <img src="/assets/img/plusefit/mockups-2.png" className="my-2" alt="" />
              </div>
              <div>
                <p className="py-10">
                  To make the checkout easier for users i added more payment
                  options to checkout process. This allow users more freedom to
                  choose whatever payment option suitable to them.
                </p>
              </div>
              <div className="lg:flex justify-around pt-10 ">
                <img src="/assets/img/plusefit/mockups-3.png" className="my-2" alt="" />
                <img src="/assets/img/plusefit/mockups-4.png" className="my-2" alt="" />
              </div>
              <div className="py-10">
                <h1 className="text-2xl font-bold">High Fidelity Prototype </h1>
                <p className="text-justify my-5 ">
                  My hi-fi prototype followed the same user flow as the lo-fi
                  prototype, and included the design changes made after the
                  usability study, as well as several changes suggested by
                  members of my team. Link to the hi-fi prototype-
                </p>
                <div className="">
                  <a
                    className="border-2 border-h-color hover:bg-h-color hover:text-white  px-8 py-1 rounded-lg"
                    href="https://www.figma.com/proto/RWmsKFvich3x1aaKlne4tH/WORKOUT-APP-PROTOTYPE?node-id=145-2&t=3cHuGm37rJigqpq1-1"
                  >
                    Hi-Fi Link
                  </a>
                </div>
                <div className="justify-items-center mt-5">
                  <img src="/assets/img/plusefit/hifi.png" className="w-6/12" alt="" />
                </div>
              </div>

              <div className="py-10">
                <h1 className="text-2xl font-bold">
                  Accessibility Considerations{" "}
                </h1>

                {/* <div className="py-10 lg:px-60">
                  <div className="grid lg:grid-cols-3 gap-5">
                    <div className="text-center mt-5 px-10 py-10 bg-gray-100 relative h-56 ">
                      <div className="justify-items-center ">
                        <PiNumberCircleOneFill className="text-7xl text-btncolor absolute bottom-48 left-28" />
                      </div>

                      <p className="text-justify mt-5">
                        I used headings with different sized text for clear
                        visual hierarchy . 
                      </p>
                    </div>
                    <div className=" text-center mt-5 px-10 py-10 bg-gray-100 relative h-56">
                      <div className="justify-items-center">
                        <PiNumberCircleTwoFill className="text-7xl text-btncolor absolute bottom-48 left-28" />
                      </div>

                      <p className=" text-justify mt-5">
                        I used landmarks to help users navigate the site,
                        including users who rely on assistive technologies
                      </p>
                    </div>
                    <div className=" text-center mt-5 px-10 py-10 bg-gray-100 relative h-56">
                      <div className="justify-items-center">
                        <PiNumberCircleThreeFill className="text-7xl text-btncolor absolute bottom-48 left-28" />
                      </div>

                      <p className=" text-justify mt-5">
                        I used contrasting colours for call to action buttons to
                        help users with low vision.
                      </p>
                    </div>
                  </div>
                </div> */}
                <div className="py-10 px-5 md:px-10 lg:px-20">
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-10">
    {/* Card 1 */}
    <div className="text-center mt-5 px-6 py-10 bg-gray-100 relative h-56 flex flex-col justify-center items-center">
      <PiNumberCircleOneFill className="text-6xl text-btncolor absolute top-8 left-1/2 transform -translate-x-1/2" />
      <p className="text-justify mt-14 px-4">
        I used headings with different sized text for clear visual hierarchy.
      </p>
    </div>

    {/* Card 2 */}
    <div className="text-center mt-5 px-6 py-10 bg-gray-100 relative h-56 flex flex-col justify-center items-center">
      <PiNumberCircleTwoFill className="text-6xl text-btncolor absolute top-8 left-1/2 transform -translate-x-1/2" />
      <p className="text-justify mt-14 px-4">
        I used landmarks to help users navigate the site, including users who rely on assistive technologies.
      </p>
    </div>

    {/* Card 3 */}
    <div className="text-center mt-5 px-6 py-10 bg-gray-100 relative h-56 flex flex-col justify-center items-center">
      <PiNumberCircleThreeFill className="text-6xl text-btncolor absolute top-8 left-1/2 transform -translate-x-1/2" />
      <p className="text-justify mt-14 px-4">
        I used contrasting colours for call-to-action buttons to help users with low vision.
      </p>
    </div>
  </div>
</div>

              </div>
              <div class="flex items-center justify-center py-20">
                <div class="grid grid-cols-2 w-3/4">
                  {/* <!-- Left Column --> */}
                  <div class="text-left h-96 content-center justify-items-end">
                    <h1 class="text-2xl font-semibold text-h-color  text-right pr-10  ">
                      Going Forward
                    </h1>
                  </div>
                  {/* <!-- Right Column --> */}
                  <div class="border-l-2 border-black h-96 content-center  pl-10">
                    <ul class="list-disc space-y-2 text-gray-800">
                      <li>Takeaways </li>
                      <li>Next Steps</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="py-10">
                <h1 className="text-2xl font-bold text-h-color">Takeaways</h1>
                <div className=" mt-10 grid lg:grid-cols-2 gap-20">
                  <div>
                    <div>
                      {" "}
                      <IoCheckbox className="text-red-900 text-7xl" />
                    </div>

                    <h1 className="text-2xl font-bold py-5">Impact:</h1>
                    <p className="text-justify">
                      Our target users shared that the design was intuitive to
                      navigate through, more engaging with the images, and
                      demonstrated a clear visual hierarchy. 
                    </p>
                  </div>
                  <div>
                    <div className="text-red-900 text-7xl">
                      <SiGoogledocs />
                    </div>
                    <h1 className="text-2xl font-bold py-5">What I Learned:</h1>
                    <p className="text-justify">
                      I learned that even a small design change can have a huge
                      impact on the user experience. The most important takeaway
                      for me is to always focus on the real needs of the user
                      when coming up with design ideas and solutions. 
                    </p>
                  </div>
                </div>
              </div>
              <div className="pt-10">
                <h1 className="text-2xl font-bold text-h-color">
                  Lets Connect
                </h1>
                {/* <div className="mt-20 lg:mt-10">
                  <div className="bg-gray-100 justify-items-center py-10 px-10 relative">
                    <div>
                      <FaPenSquare className="text-7xl text-red-900 absolute lg:bottom-40 bottom-96 lg:left-2/4 left-32 " />
                    </div>
                    <p>
                      Thank you for reviewing my work on the PulseFit: Workout
                      App!  If you’d like to see more, or would like to get in
                      touch, my contact information is provided below:
                    </p>
                    <p className="py-5">
                      <span className="font-bold">Email: </span>
                      naman61265@gmail.com
                    </p>
                    <p>
                      <span className="font-bold">LinkedIn:</span>{" "}
                      <a href="https://www.linkedin.com/in/naina-joshi-960863333/">
                        https://www.linkedin.com/in/naina-joshi-960863333/
                      </a>
                    </p>
                  </div>
                </div> */}
                <div className="mt-20 lg:mt-10">
                  <div className="bg-gray-100 flex flex-col items-center justify-center py-10 px-6 sm:px-10 relative">
                    {/* Icon */}
                    <div className="absolute top-[-3rem] lg:top-[-4rem] left-1/2 transform -translate-x-1/2">
                      <FaPenSquare className="text-7xl sm:text-8xl text-red-900" />
                    </div>

                    {/* Content */}
                    <div className="text-center">
                      <p className="text-gray-700">
                      Thank you for reviewing my work on the PulseFit: Workout
                      App!  If you’d like to see more, or would like to get in
                      touch, my contact information is provided below:
                      </p>
                      <p className="py-5 text-gray-800">
                        <span className="font-bold">Email: </span>
                        <a
                          href="mailto:nainajoshi6126@gmail.com"
                          className="hover:underline text-blue-600"
                        >
                          nainajoshi6126@gmail.com
                        </a>
                      </p>
                      <p className="text-gray-800">
                        <span className="font-bold">LinkedIn:</span>{" "}
                        <a
                          href="https://www.linkedin.com/in/naina-joshi-960863333/"
                          className="hover:underline text-blue-600"
                        >
                          LinkedIn Profile
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PulseFit;
